import { useAtom } from 'jotai'

import { notificationBarStore } from 'src/stores'

export const useNotificationBarStore = () => {
  const [notificationBarStoreValue, setNotificationBarStoreValue] = useAtom(
    notificationBarStore.state
  )

  return {
    notificationBarStoreValue,
    setNotificationBarStoreValue,
  }
}
